module.exports = __webpack_public_path__ + "8300bd7f30e0a313c1d772b49d96cb8e.ttf";